module.exports = __webpack_public_path__ + "img/link_icon_1.0da7d94.png";